"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _NotifyIcon = _interopRequireDefault(require("../../NotifyIcon"));
var _Pagination = require("./Pagination.styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Pagination = function Pagination(_ref) {
  var numberOfPages = _ref.numberOfPages,
    page = _ref.page,
    localeText = _ref.localeText,
    disabled = _ref.disabled,
    size = _ref.size,
    onChange = _ref.onChange;
  var isFirstPage = page === 1;
  var isLastPage = page === numberOfPages;
  var handlePageChange = function handlePageChange(event) {
    return onChange(+event.target.value);
  };
  var handleFirstPageClick = function handleFirstPageClick() {
    return onChange(1);
  };
  var handleLastPageClick = function handleLastPageClick() {
    return onChange(numberOfPages);
  };
  var handlePrevPageClick = function handlePrevPageClick() {
    return !isFirstPage && onChange(--page);
  };
  var handleNextPageClick = function handleNextPageClick() {
    return !isLastPage && onChange(++page);
  };
  return /*#__PURE__*/_react["default"].createElement(_Pagination.PaginationWrapper, null, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    "aria-label": "first-page",
    color: "primary",
    disabled: isFirstPage || disabled,
    onClick: handleFirstPageClick,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
    fontSize: "large",
    iconName: "doubleChevronLeft"
  })), /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    "aria-label": "previous-page",
    color: "primary",
    disabled: isFirstPage || disabled,
    onClick: handlePrevPageClick,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
    fontSize: "large",
    iconName: "chevronLeft"
  })), /*#__PURE__*/_react["default"].createElement(_Pagination.StyledSelect, {
    id: "pages",
    name: "pages",
    label: "",
    "native": true,
    value: page,
    handleChange: handlePageChange,
    disabled: disabled,
    $size: size
  }, Array(numberOfPages).fill().map(function (item, idx) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: idx + 1,
      value: idx + 1
    }, idx + 1);
  })), /*#__PURE__*/_react["default"].createElement(_Pagination.PageCountLabel, null, localeText.of, " ", numberOfPages), /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    "aria-label": "next-page",
    color: "primary",
    disabled: isLastPage || disabled,
    onClick: handleNextPageClick,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
    fontSize: "large",
    iconName: "chevronRight"
  })), /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    "aria-label": "last-page",
    color: "primary",
    disabled: isLastPage || disabled,
    onClick: handleLastPageClick,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
    fontSize: "large",
    iconName: "doubleChevronRight"
  })));
};
Pagination.propTypes = {
  numberOfPages: _propTypes["default"].number.isRequired,
  page: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  localeText: _propTypes["default"].shape({
    of: _propTypes["default"].string
  }),
  disabled: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(['small', 'medium'])
};
Pagination.defaultProps = {
  localeText: {
    of: 'of'
  },
  disabled: false,
  size: 'medium'
};
var _default = exports["default"] = Pagination;